import axios from 'axios';
import { cabecalhoDoCoordenador } from './coordenadorAtuacao';
import { ROTA_TROCA_SENHA, ehRespostaDeTrocaObrigatoria } from '../utils/trocaSenha';

export const resolveApiBaseURL = () => {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const envUrl = process.env.REACT_APP_API_URL;
  const isLocalhost = origin.includes('localhost') || origin.includes('127.0.0.1');

  // In browsers on non-local hosts, prefer same-origin HTTPS to avoid mixed-content.
  if (origin && !isLocalhost) {
    if (envUrl && envUrl.startsWith('https://')) return envUrl;
    return `${origin}/api`;
  }

  return envUrl || 'http://localhost:4000/api';
};

const resolvedBaseURL = resolveApiBaseURL();

const api = axios.create({
  baseURL: resolvedBaseURL,
  withCredentials: true
});

api.interceptors.request.use(config => {
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    console.warn('[INTERCEPTOR] Nenhum token encontrado');
  }
  const coordenador = cabecalhoDoCoordenador(config, typeof window !== 'undefined' ? window.location.pathname : '');
  if (coordenador) config.headers['X-Coordenador-Id'] = coordenador;
  return config;
});

export const RETORNO_APOS_LOGIN = 'retornoAposLogin';

// Renovação deslizante da sessão da TV do Andon: o backend devolve um token
// novo (180 dias, mesmos claims) no cabecalho X-Renovar-Token do painel, no
// máximo uma vez por dia. Troca o token no mesmo storage em que ele já estava,
// sem recarregar a página nem mexer no usuário logado.
const CABECALHO_RENOVACAO = 'x-renovar-token';
const FORMATO_JWT = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;

export const aplicarTokenRenovado = (response) => {
  const novo = response?.headers?.[CABECALHO_RENOVACAO];
  if (typeof novo !== 'string' || !FORMATO_JWT.test(novo)) return;
  try {
    if (sessionStorage.getItem('token')) sessionStorage.setItem('token', novo);
    else if (localStorage.getItem('token')) localStorage.setItem('token', novo);
    // Sem token guardado (logout no meio do caminho): não ressuscita a sessão.
  } catch (_err) { /* sem storage: segue com o token atual até o próximo dia */ }
};

// Logout automático quando o token expira ou não é enviado corretamente
api.interceptors.response.use(
  (response) => {
    aplicarTokenRenovado(response);
    return response;
  },
  (error) => {
    const status = error?.response?.status;

    // Troca de senha exigida pelo gestor: a API recusa tudo (403
    // TROCA_SENHA_OBRIGATORIA) até a pessoa definir a senha nova.
    if (ehRespostaDeTrocaObrigatoria(error) && typeof window !== 'undefined' && window.location.pathname !== ROTA_TROCA_SENHA) {
      window.location.href = ROTA_TROCA_SENHA;
      return Promise.reject(error);
    }

    if (status === 401 && !error.config?.skipAuthRedirect) {
      localStorage.removeItem('token');
      sessionStorage.removeItem('token');

      // Evita loop de redirecionamento se já estiver na tela de login
      if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
        // Sessão expirada no meio do caminho (ex.: link de chamado aberto pelo
        // e-mail): depois do login a pessoa volta para onde estava.
        try {
          sessionStorage.setItem(RETORNO_APOS_LOGIN, `${window.location.pathname}${window.location.search}`);
        } catch (_err) { /* sem storage, cai na página inicial */ }
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export default api;
